<template>
    <div class="container-fluid">
        <div class="hidden-xs">
            <h3 class="title">Order Summary <modal-help link="https://blog.zwiz.ai/zwiz-ai-product-stock-intro#order"></modal-help></h3>
            <div class="row" style="padding-bottom: 15px">
                <div class="col-md-6">
                    <date-range-picker v-model="selectedDate" ref="rangeDatePicker" @onSelectedDate="onSelectedDate"></date-range-picker>
                </div>
                <div class="col-md-6 text-right">
                    <a href="javascript:void(0);" class="btn btn-outline-primary" @click="exportOrderSummary"><i class="fa fa-print"></i></a>
                    <a href="javascript:void(0);" class="btn btn-outline-primary ml-1" @click="getOrderSummary()"><i class="fa fa-refresh"></i></a>
                </div>
            </div>
            <div>
                <ul class="nav nav-tabs hidden-xs" style="margin-bottom:15px;">
                    <li role="presentation" :class="{'active' : filterStatus == 'all'}"><a href="javascript:void(0);" @click="changeStatus('all')">All {{ badge.all > 0 ? '(' + badge.all +')' : ''}}</a></li>
                    <li role="presentation" :class="{'active' : filterStatus == 'ordered'}"><a href="javascript:void(0);" @click="changeStatus('ordered')">Ordered {{ badge.ordered > 0 ? '(' + badge.ordered +')' : ''}}</a></li>
                    <li role="presentation" :class="{'active' : filterStatus == 'paid'}"><a href="javascript:void(0);" @click="changeStatus('paid')">Paid {{ badge.paid > 0 ? '(' + badge.paid +')' : ''}}</a></li>
                    <li role="presentation" :class="{'active' : filterStatus == 'shipped'}"><a href="javascript:void(0);" @click="changeStatus('shipped')">Shipped {{ badge.shipped > 0 ? '(' + badge.shipped +')' : ''}}</a></li>
                    <li role="presentation" :class="{'active' : filterStatus == 'canceled'}"><a href="javascript:void(0);" @click="changeStatus('canceled')">Canceled {{ badge.canceled > 0 ? '(' + badge.canceled +')' : ''}}</a></li>
                </ul>

                <select name="filter_status" id="filter_status" class="form-control visible-xs-block" v-model="filterStatus" @change="getOrderSummary" style="margin-bottom:10px">
                    <option value="all">All {{ badge.all > 0 ? '(' + badge.all +')' : ''}}</option>
                    <option value="ordered">Ordered {{ badge.ordered > 0 ? '(' + badge.ordered +')' : ''}}</option>
                    <option value="paid">Paid {{ badge.paid > 0 ? '(' + badge.paid +')' : ''}}</option>
                    <option value="shipped">Shipped {{ badge.shipped > 0 ? '(' + badge.shipped +')' : ''}}</option>
                    <option value="canceled">Canceled {{ badge.canceled > 0 ? '(' + badge.canceled +')' : ''}}</option>
                </select>

                <div style="overflow-x:auto" >
                    <table class="table table-bordered table-hover" v-if="filterSummary.length > 0">
                        <thead>
                            <tr class="text-center">
                                <th style="width: 100px">Order No</th>
                                <th style="width: 150px">Products</th>
                                <th>Name / Address</th>
                                <th style="width: 100px">Price</th>
                                <th style="width: 80px">Status</th>
                                <th style="width: 100px">Channel</th>
                                <th style="width: 150px">Tracking</th>
                                <th style="width: 200px">Reminder</th>
                            </tr>
                        </thead>
                        <tbody>
                            <summary-item v-for="(order,index) in filterSummary" :key="'order_'+index" v-model="filterSummary[index]"  @updateOrder="updateOrder(order.id)"></summary-item>
                        </tbody>
                    </table>
                    <template v-else>
                        <div class="text-center" style="margin: 35px 0">
                            <img src="/static/img/assets/ecommerce/empty_shopping_cart.png" alt="" style="width: 230px">
                            <h3>Not have any order now</h3>
                            
                        </div>
                        
                    </template>
                </div>

            </div>
        </div>
        <order-summary-mobile class="hidden-sm hidden-md hidden-lg" v-model="filterSummary" @onExport="exportOrderSummary" @onRefresh="getOrderSummary" @updateOrder="updateOrder" @onChangeStatus="onChangeStatus">
            <div class="col-xs-12" slot="filter" style="margin-bottom: 15px;">
                <select class="form-control" v-model="filterStatus" @change="getOrderSummary">
                    <option value="all">All{{ badge.all > 0 ? ' (' + badge.all +')' : ''}}</option>
                    <option value="ordered">Ordered{{ badge.ordered > 0 ? ' (' + badge.ordered +')' : ''}}</option>
                    <option value="paid">Paid{{ badge.paid > 0 ? ' (' + badge.paid +')' : ''}}</option>
                    <option value="shipped">Shipped{{ badge.shipped > 0 ? ' (' + badge.shipped +')' : ''}}</option>
                    <option value="Canceled">Canceled{{ badge.canceled > 0 ? ' (' + badge.canceled +')' : ''}}</option>
                </select>
            </div>
            <date-range-picker slot="datepicker" v-model="selectedDate" ref="rangeDatePicker" @onSelectedDate="onSelectedDate"></date-range-picker>
        </order-summary-mobile>
        
    </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import VueRangedatePicker from 'vue-rangedate-picker'
import DateRangePicker from '@/components/elements/DateRangePicker'

import Editable from '@/components/elements/Editable'
import DatePicker from 'vue2-datepicker'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import SummaryItem from './SummaryItem'
import OrderSummaryMobile from "./OrderSummaryMobile";
import ModalHelp from '@/components/elements/ModalHelp'

export default {
    data: function(){
        return {
            filterStatus: 'all',
			selectedDate: {
				start: ( moment().subtract(1, 'months').toDate()),
				end: ( moment().toDate())
            },	
            summary: [],
            lang: {
                days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                placeholder: {
                date: 'Select Date',
                dateRange: 'Select Date Range'
                }
            },
            badge: {
                all : 0,
                canceled:0,
                ordered:0,
                paid:0,
                shipped:0,
            }
        }
    },
	components: {
        DateRangePicker,
        Editable,
        SummaryItem,
        OrderSummaryMobile,
        ModalHelp
    },
    computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot'
        }),
        filterSummary: function(){
            let vm = this
            let orders = []
            vm.badge = {
                all : 0,
                canceled:0,
                ordered:0,
                paid:0,
                shipped:0,
            }
            vm.badge.all = vm.summary.length

            $.each(vm.summary,function(index ,val){
                vm.badge[val.status] += 1
                if (val.status == vm.filterStatus) {
                    orders.push(val)
                } else if(vm.filterStatus == 'all') {
                    orders.push(val)
                }
            })

            return orders
        }
    },
    mounted: function(){
        this.getOrderSummary()
    },
    filters: {
        formatdate: function(value){
            return moment(value).format('YYYY/MM/DD h:mm:ss a')
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        changeStatus: function(value){
            this.filterStatus = value
        },
        getOrderSummary: function(){
            let vm = this
			let data = {
                pageid: vm.selectedBot.pageid,
                datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
                dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
                status: vm.filterStatus
            }
            vm.$store.dispatch('loading')
			api.getOrderSummary(data,function(error, response){
				if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
					return
				}
				if (response.data) {
                    vm.summary = response.data
                    if (vm.filterStatus == 'all') {
                        
                        vm.badge = {
                            all : response.all,
                            canceled: response.canceled,
                            ordered: response.ordered,
                            paid: response.paid,
                            shipped: response.shipped,
                        }
                    }
                }
                vm.$store.dispatch('loading')
			})
        },
        onSelectedDate: function(value){
            // console.log(value)
            return false
            let date = {
				start: moment(value.start).format('YYYY-MM-DD'),
				end: moment(value.end).format('YYYY-MM-DD')
			}

			this.selectedDate = date
            this.getOrderSummary()
        },
        onChangeStatus: function(index){
            let vm = this
            vm.updateOrder(index,function(){
            })
        },
        sendTrackingNo: function(index){
            this.updateOrder(index)
        },
        updateOrder: function(id,callback){
            let vm = this
            vm.$store.dispatch('loading')
            let data = vm.summary.find(function(element){
                return element.id == id
            })   
            api.editOrderSummary(data,function(error, response){
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
					return
				}
                callback()
                vm.$store.dispatch('loading')

            })
        },
        exportOrderSummary: function(){
            let vm = this
            let csvContent = "data:text/csv;charset=utf-8,";
            
            csvContent += "Order No.,Products,Name and Address,Price,Tracking No.,Created Date"  + "\r\n";
            $.each(vm.summary,function(index,val){
                let row = '"' + val.id+ '","' + val.productdetail.replace(/\r?\n|\r/g, " / ")  + '","' + val.nameaddress.replace(/\r?\n|\r/g, " / ") + '","' + numeral(val.amount).format("0,0.00").toString() + '","' + val.trackingno.replace(/\r?\n|\r/g, " / ") + '","' + moment(val.timestamp).format('DD/MM/YYYY') + '"'
                csvContent += row + "\r\n";
            })

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("style","overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "order_summary_"+moment().format('YYYY_MM_DD')+".csv");
            link.innerHTML= "Click Here to download";
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-order-summary.vue